import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const serviciosLinks = [
    { name: 'Hormigón Impreso', path: '/servicios' },
    { name: 'Hormigón Desactivado', path: '/servicios' },
    { name: 'Hormigón Pulido', path: '/servicios' },
    { name: 'Piscinas Arelite', path: '/servicios' },
    { name: 'Protecciones de Acabados', path: '/servicios/protecciones-acabados' },
  ];

  return (
    <footer className="bg-dark text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <Link to="/" onClick={scrollToTop} className="inline-block mb-4 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/5fa39b647fe9b9756d6d13910558d3e0/22dc4b37e72a444c4964897dd25d2553.png" 
                alt="HORMI PREMIUM" 
                className="h-12 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 text-sm mb-6">Superficies que inspiran</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Tu email"
                className="flex-1 px-4 py-2 bg-transparent border border-white/30 rounded-lg text-sm focus:outline-none focus:border-primary"
              />
              <button className="w-10 h-10 flex items-center justify-center bg-primary rounded-lg hover:bg-[#1873CC] transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Servicios</h4>
            <ul className="space-y-3">
              {serviciosLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} onClick={scrollToTop} className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Empresa</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" onClick={scrollToTop} className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link to="/proyectos" onClick={scrollToTop} className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Proyectos
                </Link>
              </li>
              <li>
                <a href="#zona-servicio" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  Zona de Servicio
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line"></i>
                </div>
                <a href="tel:+34640877479" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  640 877 479
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line"></i>
                </div>
                <a href="mailto:hormipremium@gmail.com" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                  hormipremium@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line"></i>
                </div>
                <span className="text-gray-400">Calle Cruces 54A, Manilva, Málaga 29691</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line"></i>
                </div>
                <span className="text-gray-400">Lun-Vie: 8:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 HORMI PREMIUM SL. Todos los derechos reservados
            </p>

            <div className="flex items-center gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/20 rounded hover:border-primary hover:text-primary transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-line"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/20 rounded hover:border-primary hover:text-primary transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/20 rounded hover:border-primary hover:text-primary transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-line"></i>
              </a>
            </div>

            <div className="flex items-center gap-4 text-sm">
              <a href="#" className="text-gray-400 hover:text-primary transition-colors cursor-pointer whitespace-nowrap">
                Política de Privacidad
              </a>
              <span className="text-gray-600">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors cursor-pointer whitespace-nowrap">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
